import Markdown from "markdown-to-jsx";
import React from "react";
import { Widget, WidgetProps } from "@rjsf/utils";

export const MarkdownTextWidget: Widget = ({ label }: WidgetProps) => {
  return <Markdown className="form-text">{label}</Markdown>;
};
